import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Tracking } from '@panamax/app-state';
import { genericTracingTransformer } from '@shared/tracking/tracing/generic-tracing-transformer';
import { IMPORTED_ORDERS_TRACING_ACTIONS } from './imported-orders-tracing.actions';
import { ImportedOrdersTracingConstants } from './imported-orders-tracing.constants';

@Injectable({
  providedIn: 'root',
})
export class ImportedOrdersTracingService {
  constructor(private store: Store) {}

  static deepRemoveUndefined(obj) {
    if (typeof obj !== 'object' || obj === null || Array.isArray(obj)) {
      return obj;
    }

    return Object.entries(obj).reduce((acc, [key, value]) => {
      if (
        value !== undefined &&
        value !== null &&
        JSON.stringify(value) !== '{}'
      ) {
        acc[key] = ImportedOrdersTracingService.deepRemoveUndefined(value);
      }
      return acc;
    }, {});
  }
  traceImportedOrdersPageLoad = () => {
    const tracking: Tracking = {
      tracing: {
        data: {
          traceContext: ImportedOrdersTracingConstants.capability,
          isEndOfTrace: true,
          isStartOfTrace: true,
          attributes: {
            event: ImportedOrdersTracingConstants.importedOrdersPageLoad,
          },
        },
        transformFunc: genericTracingTransformer,
      },
    };
    this.store.dispatch(
      IMPORTED_ORDERS_TRACING_ACTIONS.traceImportedOrdersPageLoad({
        tracking: ImportedOrdersTracingService.deepRemoveUndefined(tracking),
      }),
    );
  };
}
